export const UPDATE_PRODUCT_INFORMATIONS = 'UPDATE_PRODUCT_INFORMATIONS'

export const UPDATE_CURRENT_PRODUCT = 'UPDATE_CURRENT_PRODUCT'

export const UPDATE_OPEN_PRODUCT = 'UPDATE_OPEN_PRODUCT'

export const UPDATE_ADD_TO_CART_BUTTON_STATE = 'UPDATE_ADD_TO_CART_BUTTON_STATE'

export const UPDATE_TRADUCTION = 'UPDATE_TRADUCTION'
